import { PropsWithChildren, useContext } from "react";
import { Tabs } from "@mui/material";
import { TabsReactContext } from "src/components-mui/tabs/tabs-context";
import { getTabsListCustomVariantStyles } from "src/components-mui/tabs/tabs-list.styles";

export interface ITabsListProps {
    customVariant?: "pills" | "full";
}

export const TabsList = ({ children, customVariant }: PropsWithChildren<ITabsListProps>) => {
    const context = useContext(TabsReactContext);

    return (
        <Tabs value={context.currentTab} onChange={(_, value) => context.setCurrentTab(value)} sx={getTabsListCustomVariantStyles(customVariant)}>
            {children}
        </Tabs>
    );
};
